import _ from 'lodash'
import store from '@/store'
import i18n from '@/i18n'
import router from '@/router/routes'
import { deviceType } from '@/utils/common'

const PAGE_STATUS = {
  OPEN: 'OPEN',
  ACTIVE: 'ACTIVE',
  LEAVE: 'LEAVE',
  BACK: 'BACK',
  HIDDEN: 'HIDDEN',
  CLOSE: 'CLOSE'
}

let isActive = false
// 定义全局变量记录最后一次交互时间
let lastActivityTime = Date.now()
const inactivityThresholdMs = 3 * 60 * 1000 // 3分钟

// 定义全局上报时间间隔
const reportDurationTime = 5 * 60 * 1000 // 5分钟

// 定义检测活跃状态的定时器间隔时间
const activeCheckIntervalTime = 1000 * 60 // 1分钟

// 不同窗口使用 id 区分， 防止发生多线程问题
const tabId = Math.random().toString(36).substring(2)

// 进入页面时调用
function recordBehaviors (to) {
  if (!checkAccountIsHr()) {
    return
  }
  const accountId = store.state.account.currentAccount.id
  if (!accountId) {
    return
  }

  const pageUrl = to.fullPath
  const cacheKey = getCacheKey(pageUrl)
  const pageTitle = i18n.t(to.meta.titleI18nKey)
  const { device, browser } = getDeviceTypeAndBrowser()
  const reportDate = {
    start_time: Date.now(),
    end_time: null,
    account_id: accountId,
    device: device,
    browser: browser,
    page_url: pageUrl,
    page_title: pageTitle,
    duration_time: 0,
    status: PAGE_STATUS.OPEN
  }
  localStorage.setItem(cacheKey, JSON.stringify(reportDate))
  reportBehaviorsData(JSON.stringify(reportDate), PAGE_STATUS.OPEN)
}

// 更新页面状态 和 时间
function updateBehaviorsStatus (status, url) {
  if (!checkAccountIsHr()) {
    return
  }
  const accountId = store.state.account.currentAccount.id
  if (!accountId) {
    return
  }
  // 此处需要根据路由获取页面名称
  const pageUrl = url || router.app._route.fullPath
  const cacheKey = getCacheKey(pageUrl)
  const reportStr = localStorage.getItem(cacheKey)
  if (reportStr) {
    const reportDate = JSON.parse(reportStr)
    reportDate.status = status
    reportDate.end_time = Date.now()
    reportDate.duration_time += Math.ceil((reportDate.end_time - reportDate.start_time) / 1000)
    reportDate.start_time = Date.now()
    localStorage.setItem(cacheKey, JSON.stringify(reportDate))
  }
}

function updateBehaviorsStart (status, url) {
  if (!checkAccountIsHr()) {
    return
  }
  const accountId = store.state.account.currentAccount.id
  if (!accountId) {
    return
  }
  const pageUrl = url || router.app._route.fullPath
  const cacheKey = getCacheKey(pageUrl)
  const reportStr = localStorage.getItem(cacheKey)
  if (reportStr) {
    const reportDate = JSON.parse(reportStr)
    reportDate.status = status
    reportDate.end_time = null
    reportDate.duration_time = 0
    reportDate.start_time = Date.now()
    localStorage.setItem(cacheKey, JSON.stringify(reportDate))
    reportBehaviorsData(JSON.stringify(reportDate), status)
  }
}

// 批量上报
function batchReportData () {
  if (!checkAccountIsHr()) {
    return
  }
  const data = _.chain(0).range(localStorage.length).map(i => {
    const key = localStorage.key(i)
    if (key && key.startsWith(`${tabId}_CURRENT_BEHAVIOR_`)) {
      const reportStr = localStorage.getItem(key)
      if (reportStr) {
        return JSON.parse(reportStr)
      }
    }
  }).filter().value()
  fetch(`${process.env.NODE_ENV === 'production' ? '' : '/api'}/django_rest/account/batch-report/hr-behavior/`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 上报数据
function reportBehaviorsData (reportStr, status) {
  if (reportStr) {
    const reportDate = JSON.parse(reportStr)
    reportDate.status = status
    // 上报
    fetch(`${process.env.NODE_ENV === 'production' ? '' : '/api'}/django_rest/account/hr-behavior/`, {
      method: 'POST',
      body: JSON.stringify(reportDate),
      headers: {
        'Content-Type': 'application/json'
      },
      keepalive: true
    })
  }
}

// 获取缓存 key
function getCacheKey (pageUrl) {
  const accountId = store.state.account.currentAccount.id
  if (!accountId) {
    return
  }
  if (!pageUrl) {
    pageUrl = router.app._route.fullPath
  }
  return `${tabId}_CURRENT_BEHAVIOR_${accountId}_${pageUrl}`
}

// 获取浏览器类型
function getBrowserType () {
  const userAgent = navigator.userAgent.toLocaleLowerCase()
  let browserType = null
  if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
    const isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
    const isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11
    if (isEdge) {
      browserType = 'Edge'
    } else {
      browserType = 'IE'
    }
  } else if (userAgent.match(/firefox/) != null) {
    browserType = 'Firefox'
  } else if (userAgent.match(/ucbrowser/) != null) {
    browserType = 'UC'
  } else if (userAgent.match(/opera/) != null || userAgent.match(/opr/) != null) {
    browserType = 'Opera'
  } else if (userAgent.match(/bidubrowser/) != null) {
    browserType = 'Baidu'
  } else if (userAgent.match(/metasr/) != null) {
    browserType = 'Sougou'
  } else if (userAgent.match(/tencenttraveler/) != null || userAgent.match(/qqbrowse/) != null) {
    browserType = 'QQ'
  } else if (userAgent.match(/maxthon/) != null) {
    browserType = 'Maxthon'
  } else if (userAgent.match(/chrome/) != null) {
    browserType = 'Chrome'
  } else if (userAgent.match(/safari/) != null) {
    browserType = 'Safari'
  } else {
    browserType = 'Others'
  }
  return browserType
}

function getDeviceTypeAndBrowser () {
  const browserType = getBrowserType()
  let device = 'PC'
  if (deviceType.isPc) {
    device = 'PC'
  } else if (deviceType.isAndroid) {
    device = 'ANDROID'
  } else if (deviceType.isiOS) {
    device = 'iOS'
  }
  return { device, browser: browserType }
}

function resetActive () {
  if (!checkAccountIsHr()) {
    return
  }
  isActive = true
  updateBehaviorsStatus(PAGE_STATUS.BACK)
  lastActivityTime = Date.now()
}

function createInterval () {
  activeCheckIntervalId = setInterval(() => {
    if (!checkAccountIsHr()) {
      return
    }
    const currentTime = Date.now()
    if (currentTime - lastActivityTime > inactivityThresholdMs) {
      updateBehaviorsStatus(PAGE_STATUS.LEAVE)
      batchReportData()
      isActive = false
    } else {
      isActive = true
    }
  }, activeCheckIntervalTime)

  // 5分钟上报一次
  intervalId = setInterval(() => {
    if (!checkAccountIsHr()) {
      return
    }
    if (isActive) {
      // 批量上报
      batchReportData()
      isActive = false
    }
  }, reportDurationTime)
}

//  定时检查用户是否操作页面
let activeCheckIntervalId = setInterval(() => {
  if (!checkAccountIsHr()) {
    return
  }
  const currentTime = Date.now()
  if (currentTime - lastActivityTime > inactivityThresholdMs) {
    updateBehaviorsStatus(PAGE_STATUS.LEAVE)
    batchReportData()
    isActive = false
  } else {
    isActive = true
  }
}, activeCheckIntervalTime)

// 5分钟上报一次
let intervalId = setInterval(() => {
  if (!checkAccountIsHr()) {
    return
  }
  if (isActive) {
    // 批量上报
    batchReportData()
    isActive = false
  }
}, reportDurationTime)

window.addEventListener('load', () => {
  if (!checkAccountIsHr()) {
    return
  }
  isActive = true
})

document.addEventListener('mousemove', _.debounce(resetActive, 5000))
document.addEventListener('mousewheel', _.debounce(resetActive, 5000))
document.addEventListener('keypress', _.debounce(resetActive, 5000))

// 页面可见状态变化时
document.addEventListener('visibilitychange', () => {
  if (!checkAccountIsHr()) {
    return
  }
  if (document.hidden) {
  // 页面不可见时执行的操作
    updateBehaviorsStatus(PAGE_STATUS.HIDDEN)
    batchReportData()
    clearInterval(intervalId)
    clearInterval(activeCheckIntervalId)
    isActive = false
  } else {
    updateBehaviorsStart(PAGE_STATUS.ACTIVE)
    lastActivityTime = Date.now()
    createInterval()
  }
})

// 页面关闭时执行的操作
window.addEventListener('beforeunload', () => {
  if (!checkAccountIsHr()) {
    clearInterval(intervalId)
    clearInterval(activeCheckIntervalId)
    return
  }
  updateBehaviorsStatus(PAGE_STATUS.CLOSE)
  batchReportData()
  const pageUrl = router.app._route.fullPath
  const cacheKey = getCacheKey(pageUrl)
  localStorage.removeItem(cacheKey)
  isActive = false
  clearInterval(intervalId)
  clearInterval(activeCheckIntervalId)
})

function checkAccountIsHr () {
  return store.state.account.currentAccount.type === 'company'
}

export async function setup () {
  router.beforeEach((to, from, next) => {
    // 统计时间
    recordBehaviors(to)
    if (from) {
      updateBehaviorsStatus(PAGE_STATUS.CLOSE, from.fullPath)
    }
    next()
  })
}
